import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class MagicMarkdownService {
    public constructor() {

    }

    public formatText(text: string, useSmallSymbols: boolean = false): string {
        var symbolClass = useSmallSymbols ? "symbol-magic-small" : "symbol-magic";

        // Remove the separator from split mana cost symbols. For example "{U/B}" to "{UB}"
        text = text.replaceAll(
            /((?<={[A-Z])\/)/g, 
            "");

        // Replace the symbol text with the abbr with the symbol svg as the background
        text = text.replaceAll(
            /{(.*?)}/g, 
            `</span><span class=\"${symbolClass}\ relative"><img class="absolute top-[3px]" src=\"https://images.pondertcg.com/magic/symbol/$1.svg\"/></span><span>`);
            
        return `<div class="items-center"><span>${text}</span></div>`;
    }

    public formatFlavorText(text: string): string {
        // Unformat nested italics.
        text = text.replaceAll(
            /\*(.*?)\*/g,
            "<span class=\"not-italic\">$1</span>");

        return text;
    }
}